import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import "./i18n";
import { installTranslateDomPatch } from "./common/translateDomPatch";

Sentry.init({
  dsn: "https://d8de44f003a999d57c6d06aa348f5f06@o1112556.ingest.us.sentry.io/4509152155271168",
  integrations: [new BrowserTracing({ traceFetch: false, traceXHR: false })],
  environment: process.env.NODE_ENV || "development",
  // Scripts injected into the page by browser extensions reject with this bare
  // string when their host bridge goes away. It appears as an UnhandledRejection.
  ignoreErrors: ["Object Not Found Matching Id"],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.1,
  release: process.env.VERSION,
});

installTranslateDomPatch();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
